import type { AuthRepository, SignupRequest } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type SignupInput = {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	password: string;
	language: string;
};

export type SignupUseCase = UseCase<SignupInput, string>;

export function signupBuilder(authRepository: AuthRepository): SignupUseCase {
	return async function signup(input: SignupInput): Promise<string> {
		const firstName = stringValueObject().validate('firstName', input.firstName);
		const lastName = stringValueObject().validate('lastName', input.lastName);
		const email = stringValueObject().validate('email', input.email);
		const phone = stringValueObject().validate('phone', input.phone);
		const password = stringValueObject().validate('password', input.password);
		const language = stringValueObject().validate('language', input.language);

		const signupRequest: SignupRequest = {
			firstName,
			lastName,
			email,
			phone,
			password,
			language
		};

		return authRepository.signup(signupRequest);
	};
}
